import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalWizardComponent, ModalWizardPageComponent, ScApiService } from '@sc-ui';
import { DemoService } from 'src/services/demo.service';
import { texts } from './modal-request-analysis.texts';

@Component({
  standalone: false,
  selector: 'app-modal-request-analysis',
  templateUrl: './modal-request-analysis.component.html',
  styleUrls: ['./modal-request-analysis.component.scss']
})
export class ModalRequestAnalysisComponent {

  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  project: any;

  @ViewChild('modal')
  modal: ModalWizardComponent;

  @ViewChild('request')
  requestPage: ModalWizardPageComponent;

  @ViewChild('confirmation')
  confirmationPage: ModalWizardPageComponent;

  isRequesting = false;

  // optional, lands in the request's activity for whoever prepares the analysis
  comment = '';

  @Output()
  requested = new EventEmitter<any>();

  constructor(private api: ScApiService, private demo: DemoService) { }

  show(project) {
    this.project = project;
    this.comment = '';
    this.modal.show(this.requestPage);
  }

  requestAnalysis() {

    if (this.isRequesting) return;

    // demo requests are only confirmed, so the project is unchanged after a reload
    if (this.demo.isActive) {
      this.modal.navigateTo(this.confirmationPage);
      this.requested.emit(this.project);
      return;
    }

    this.isRequesting = true;

    this.api.post('projects/' + this.project.Id + '/request-analysis', { Comment: this.comment }).subscribe(() => {
      this.modal.navigateTo(this.confirmationPage);
      this.isRequesting = false;
      this.requested.emit(this.project);
    });
  }
}
